import { render, staticRenderFns } from "./newTripMain.vue?vue&type=template&id=5bc924de&scoped=true&"
import script from "./newTripMain.vue?vue&type=script&lang=js&"
export * from "./newTripMain.vue?vue&type=script&lang=js&"
import style0 from "./newTripMain.vue?vue&type=style&index=0&id=5bc924de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc924de",
  null
  
)

/* custom blocks */
import block0 from "./newTripMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports